import {
  ISettingContainerBaseProps,
  SettingContainer,
} from "./SettingContainer"

export function SettingStatic({
  title,
  description,
  value,
  compact,
  ...props
}: ISettingContainerBaseProps & { value: React.ReactNode }) {
  return (
    <SettingContainer
      title={title}
      description={description}
      displayValue={value}
      InputComponent={null}
      compact={compact}
      {...props}
      // We are using async here to wrap the return in a promise without the new Promise boilerplate
      // eslint-disable-next-line @typescript-eslint/require-await
      onSave={async () => ({ isSuccess: true })}
    />
  )
}
